import createTableStore from "ds/components/Table/store/useTableStore";

import {
  AZURE_USED_BY_AUTOATTACHED_TABLE_STORAGE_KEY,
  AZURE_USED_BY_MANUAL_TABLE_STORAGE_KEY,
  USED_BY_COLUMN_CONFIG,
} from "./constants";

export const useIntegrationsAzureUsedByManualTableStore = createTableStore({
  storageKey: AZURE_USED_BY_MANUAL_TABLE_STORAGE_KEY,
  config: USED_BY_COLUMN_CONFIG,
  version: 2,
});

export const useIntegrationsAzureUsedByAutoattachedTableStore = createTableStore({
  storageKey: AZURE_USED_BY_AUTOATTACHED_TABLE_STORAGE_KEY,
  config: USED_BY_COLUMN_CONFIG,
  version: 2,
});
